<template>
    <v-dialog class="application-cru" v-model="showDialog" max-width="750px" :persistent="true">
        <v-card>
            <v-card-title>{{ dialogTitle }}</v-card-title>
            <v-card-text>
                <v-form v-model="valid" v-on:submit.prevent>
                    <LabelValue
                        v-if="editApplication.id !== null"
                        :label="'ID'"
                        :value="editApplication.id"
                    />
                    <v-text-field
                        :disabled="loading"
                        :value="editApplication.app"
                        @input="updateApp"
                        :rules="appRules"
                        label="Anwendungsname"
                    ></v-text-field>
                    <v-textarea
                        :disabled="loading"
                        :value="editApplication.description"
                        @input="updateDescription"
                        :rules="descriptionRules"
                        label="Beschreibung"
                    ></v-textarea>
                    <LabelValue
                        v-if="editApplication.id !== null"
                        :label="'Erstellt'"
                        :value="editApplication.createdAt"
                    />
                    <LabelValue
                        v-if="editApplication.id !== null"
                        :label="'Aktualisiert'"
                        :value="editApplication.updatedAt"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    outlined
                    @click="closeDialog"
                    :disabled="loading || processing"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    color="success"
                    outlined
                    @click="submit"
                    :loading="processing"
                    :disabled="loading || processing || !valid"
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
} from 'vuex';
import LabelValue from '@/components/LabelValue.vue';

export default {
    name: 'ApplicationCRU',
    components: {
        LabelValue,
    },
    data() {
        return {
            valid: false,
            appRules: [
                v => v.length >= 3 || 'Der Anwendungsname muss mindestens 3 Zeichen lang sein.',
                v => /^[a-zA-Z0-9_-]{3,128}$/.test(v) || 'Der Anwendungsname darf nur aus '
                    + 'Buchstaben, Zahlen und den Zeichen \'-\' und \'_\' bestehen.',
            ],
            descriptionRules: [
                v => v.trim().length >= 3 || 'Die Beschreibung muss mindestens 3 Zeichen lang sein.',
            ],
        };
    },
    computed: {
        ...mapGetters('applications', ['dialogTitle']),
        ...mapState('applications', [
            'editApplication',
            'showDialog',
            'loading',
            'processing',
        ]),
    },
    methods: {
        ...mapActions('applications', ['saveApplication']),
        ...mapMutations('applications', ['closeDialog', 'updateApp', 'updateDescription']),
        ...mapMutations('snackbar', ['error', 'success']),
        submit() {
            if (this.valid) {
                this.saveApplication()
                    .then(() => {
                        this.success('Application erfolgreich gespeichert.');
                    })
                    .catch(() => {
                        this.error('Es ist ein Fehler aufgetreten.');
                    });
            }
        },
    },
};

</script>
<style scoped lang="scss"></style>
